module.exports = __webpack_public_path__ + "img/clip_image144.26573fc0.png";